import React from 'react';
import withDrawingContainer, { withDrawingContainerProps } from './withDrawingContainer';
import {
  DrawingType,
  DropLocationUpdateDetails,
  LightPathDrawing as LightPathDrawingType,
} from '../constants';
import { Group, Rect } from 'react-konva';
import { getContinuousLightPathSize, getDiscreteLightPathSize } from '../utils';
import LightPathDrawing from './lightPathDrawing';

interface Props extends withDrawingContainerProps {
  lightPaths: LightPathDrawingType[];
}

const renderLightPaths = (
  lightPaths: LightPathDrawingType[],
  roiX: number,
  roiY: number,
  roiWidth: number,
  roiHeight: number,
) => {
  return lightPaths.map((lightPath, index) => {
    let newlightPath: LightPathDrawingType;
    if (lightPath.isDiscrete === false) {
      newlightPath = getContinuousLightPathSize(
        lightPath,
        roiWidth,
        roiHeight,
      ) as LightPathDrawingType;
    } else {
      newlightPath = getDiscreteLightPathSize(lightPath, roiWidth, roiHeight);
    }

    const { id, rectangleF, color, name } = newlightPath;
    const { width: lpWidth, height: lpHeight } = rectangleF;
    const calcxCenter = roiX - newlightPath.rectangleF.width / 2 + roiWidth / 2;
    const calcyCenter = roiY - newlightPath.rectangleF.height / 2 + roiHeight / 2;

    newlightPath.rectangleF.x = calcxCenter;
    newlightPath.rectangleF.y = calcyCenter;

    return (
      <LightPathDrawing
        key={index}
        id={id}
        x={(roiX - calcxCenter) * -1}
        y={(roiY - calcyCenter) * -1}
        width={lpWidth}
        height={lpHeight}
        color={color}
        name={name}
      />
    );
  });
};

const dropLocationDrawing = (props: Props) => {
  const { id, x, y, width, height, rectRef, lightPaths, isSelected } = props;
  return (
    <Group id={`droplocationdrawing-group-${id}`}>
      <Rect
        id={`droplocationdrawing-rect-${id}`}
        ref={rectRef}
        width={width}
        height={height}
        fill={isSelected ? 'gray' : null}
        stroke={'red'}
        strokeWidth={isSelected ? 3 : 2}
        opacity={isSelected ? 0.5 : 1}
        shadowBlur={isSelected ? 10 : 0}
        shadowColor={isSelected ? 'black' : ''}
        shadowOpacity={isSelected ? 5 : 0}
        shadowEnabled={isSelected ? true : false}
      />
      {isSelected &&
        lightPaths?.length &&
        renderLightPaths(lightPaths, x, y, width, height)}
    </Group>
  );
};
const moveActionPreProcessor = (
  props: Props,
  x: number,
  y: number,
): DropLocationUpdateDetails => {
  const {
    x: transformedX,
    y: transformedY,
    height: dbHeight,
    width: dbWidth,
  } = props.tpObject.convertRectangleDrawingForDb(x, y, props.width, props.height);
  return {
    x,
    y,
    width: props.width,
    height: props.height,
    dbXCenterOffset: transformedX,
    dbYCenterOffset: transformedY,
    dbWidth,
    dbHeight,
  };
};

const transformActionPreProcessor = (
  props: Props,
  width: number,
  height: number,
): DropLocationUpdateDetails => {
  const {
    x: dbXCenterOffset,
    y: dbYCenterOffset,
    width: transformedWidth,
    height: transformedHeight,
  } = props.tpObject.convertRectangleDrawingForDb(props.x, props.y, width, height);
  const { x, y } = props;
  return {
    x,
    y,
    width,
    height,
    dbXCenterOffset,
    dbYCenterOffset,
    dbWidth: transformedWidth,
    dbHeight: transformedHeight,
  };
};

export default withDrawingContainer(
  dropLocationDrawing,
  DrawingType.DropLocation,
  moveActionPreProcessor,
  transformActionPreProcessor,
);
